import { Injectable } from '@angular/core';
import { AbstractControl, Validators, ValidatorFn, UntypedFormArray } from '@angular/forms';

Injectable();
export class EdpValidators extends Validators {
  static username(control: AbstractControl) {
    const re = /^[a-zA-Z0-9_.+-]+$/;

    return re.test(control.value) || !control.value ? null : { invalidUsername: true };
  }

  static PasswordNotEqualToLast(control: AbstractControl) {
    const oldPassword = control.get('oldPwd').value;
    const password = control.get('pwd').value;
    if (oldPassword === password && oldPassword !== '' && password !== '') {
      control.get('pwd').setErrors({ PasswordNotEqualToLast: true });
    } else {
      return null;
    }
  }

  static MatchPassword(control: AbstractControl) {
    const password = control.get('pwd').value;
    const confirmPassword = control.get('confirmPwd').value;
    if (password !== confirmPassword && confirmPassword !== '' && password !== '') {
      control.get('confirmPwd').setErrors({ MatchPassword: true });
    } else {
      return null;
    }
  }

  static postalCode(control: AbstractControl) {
    const re = /(^[0-9]{4}[0-9]{3}$)/;

    return re.test(control.value) || !control.value ? null : { invalidPostalCode: true };
  }

  static allPhoneNumber(control: AbstractControl) {
    const re = new RegExp(/(^\(\+[0-9]{2,3}\)\s?[0-9]{9}$)|(^\+([0-9]{2,3})\s?[0-9]{9}$)|(^[0-9]{9}$)/);

    return re.test(control.value) || !control.value ? null : { invalidPhoneNumber: true };
  }

  static mobilePhoneNumber(control: AbstractControl) {
    const re =
      /(^[+]{1}[0-9]{3}[9]{1}[1,2,3,6]{1}[0-9]{7}$)|(^[0]{2}[0-9]{3}[9]{1}[1,2,3,6]{1}[0-9]{7}$)|(^[9]{1}[1,2,3,6]{1}[0-9]{7}$)/;

    return re.test(control.value) || !control.value ? null : { invalidMobileNumber: true };
  }

  static phoneNumber(control: AbstractControl) {
    const re = /(^[2]{1}[0-9]{8}$)|(^[9]{1}[1,2,3,6]{1}[0-9]{7}$)/;

    return re.test(control.value) || !control.value ? null : { invalidPhoneNumber: true };
  }

  static messagingProcessIdentifier(control: AbstractControl) {
    const re = /(^[A-Z]{3}[\d]{4}[A-Z]{2}[\d]{14}$)/;

    return re.test(control.value) || !control.value ? null : { invalidProcessIdentifier: true };
  }

  static cpe(control: AbstractControl) {
    const codVer = {
      0: 'T',
      1: 'R',
      2: 'W',
      3: 'A',
      4: 'G',
      5: 'M',
      6: 'Y',
      7: 'F',
      8: 'P',
      9: 'D',
      10: 'X',
      11: 'B',
      12: 'N',
      13: 'J',
      14: 'Z',
      15: 'S',
      16: 'Q',
      17: 'V',
      18: 'H',
      19: 'L',
      20: 'C',
      21: 'K',
      22: 'E',
    };
    let charA = '';
    let charB = '';
    const regex = /[A-Z]{2}/;

    if (control.value) {
      const value = control.value + '';
      let cpeError = false;
      const sCPE = value.trim().toUpperCase();

      // First two characters must match PT.
      // The sixteen characters after the first two must be digits.
      if (
        sCPE &&
        sCPE.length === 20 &&
        sCPE.substring(0, 2) === 'PT' &&
        Number(sCPE.substring(2, 18)) &&
        regex.test(sCPE.substring(18))
      ) {
        cpeError = true;
        let x = parseInt(sCPE.substring(2, 18), 10);
        x = x % 529;
        const y = Math.floor(parseFloat(x.toString()) / 23);
        const z = x % 23;
        if (z < 23 && y < 23) {
          charA = codVer[parseInt(y.toString(), 10)];
          charB = codVer[parseInt(z.toString(), 10)];
          if (charA !== sCPE.substring(18, 19) || charB !== sCPE.substring(19, 20)) {
            cpeError = false;
          }
        } else {
          cpeError = false;
        }
      }

      return cpeError ? null : { invalidCpe: true };
    } else {
      return null;
    }
  }

  static date(control: AbstractControl): boolean {
    const dtRegex = new RegExp(/\b\d{4}[\/-]\d{1,2}[\/-]\b\d{1,2} (0\d|1[01]):[0-5]\d:[0-5]\d$\b/);

    return dtRegex.test(control.value);
  }

  static dateInterval(dateStart: any, dateEnd: any): boolean {
    let validInterval = true;

    if (dateStart && dateEnd) {
      // Check if dateEnd is <= dateStart
      if (dateEnd < dateStart) {
        validInterval = false;
      }
    }

    return validInterval;
  }

  public findRequiredFields(form) {
    const requiredFields = [];
    const controls = form.controls;
    for (const name in controls) {
      if (controls[name].errors && controls[name].errors.required) {
        requiredFields.push(name);
      }
    }

    return requiredFields.length > 0;
  }

  static minSelectedCheckboxes(min = 1) {
    const validator: ValidatorFn = (formArray: UntypedFormArray) => {
      const totalSelected = formArray.controls
        // get a list of checkbox values (boolean)
        .map((control) => control.value)
        // total up the number of checked checkboxes
        .reduce((prev, next) => (next ? prev + next : prev), 0);

      // if the total is not greater than the minimum, return the error message
      return totalSelected >= min ? null : { required: true };
    };

    return validator;
  }

  static taxNumberWithCountryCode(control: AbstractControl) {
    const VALIDATION_BY_COUNTRY_PREFIX = {
      AT: () => null,
      BE: () => null,
      BG: () => null,
      HR: () => null,
      CY: () => null,
      CZ: () => null,
      DK: () => null,
      EE: () => null,
      FI: () => null,
      FR: () => null,
      DE: () => null,
      EL: () => null,
      HU: () => null,
      IE: () => null,
      IT: () => null,
      LV: () => null,
      LT: () => null,
      LU: () => null,
      MT: () => null,
      NL: () => null,
      PL: () => null,
      PT: (taxNumber) => EdpValidators.taxNumberValidator({ value: taxNumber } as AbstractControl),
      RO: () => null,
      SK: () => null,
      SI: () => null,
      ES: () => null,
      SE: () => null,
    };
    const VALID_PREFIX = Object.keys(VALIDATION_BY_COUNTRY_PREFIX);
    const taxCode = control.value;

    const extractPrefix = (): string => {
      let lastPositionWithLetter = -1;
      for (let i = 0; i < taxCode.length; i++) {
        if (/^[a-zA-Z]+$/.test(taxCode[i]) && lastPositionWithLetter === i - 1) {
          lastPositionWithLetter = i;
        }
        if (i === 1) {
          break;
        }
      }

      return taxCode.slice(0, lastPositionWithLetter + 1);
    };

    if (!taxCode) {
      return null;
    }

    const prefix = extractPrefix();
    if (!taxCode[0].match(/[a-z]/i) || !VALID_PREFIX.includes(prefix)) {
      return { invalidTaxNumberPrefix: true };
    }

    const taxNumber = taxCode.replace(prefix, '');
    if (!taxNumber) {
      return { invalidTaxNumber: true };
    }

    return VALIDATION_BY_COUNTRY_PREFIX[prefix](taxNumber);
  }

  static taxNumberValidator(control: AbstractControl) {
    const taxNumber = control.value;
    if (!taxNumber) {
      return null;
    }
    let ctrl = 0;
    if (taxNumber.length === 9) {
      const added =
        taxNumber[7] * 2 +
        taxNumber[6] * 3 +
        taxNumber[5] * 4 +
        taxNumber[4] * 5 +
        taxNumber[3] * 6 +
        taxNumber[2] * 7 +
        taxNumber[1] * 8 +
        taxNumber[0] * 9;
      const mod = added % 11;
      if (mod === 0 || mod === 1) {
        ctrl = 0;
      } else {
        ctrl = 11 - mod;
      }

      if (parseInt(taxNumber[8], 10) === ctrl) {
        return null;
      } else {
        return { invalidTaxNumber: true };
      }
    } else {
      return { invalidTaxNumber: true };
    }
  }

  /**
   * Validates whether the given string is an valid e-mail address (not-external AD)
   * @param control
   * @returns {} | null
   */
  static notDeprecatedADEmail(control: AbstractControl): {} | null {
    if (control.value.includes('@eedp.edp.pt')) {
      return { deprecatedADEmail: true };
    }

    return null;
  }

  /**
   * Production CPE validation
   * @param control
   * @returns {} | null
   */
  static productionCpe(control: AbstractControl): {} | null {
    const VALIDATE_PREFIX = ['PT0001', 'PT000297', 'PT000299'];
    const { value } = control;

    if (VALIDATE_PREFIX.some((item: string) => value.startsWith(item))) {
      return null;
    }

    return { invalidCpeProduction: true };
  }

  /**
   * The function checks if the value of a control starts with any of the specified prefixes and
   * returns null if it does, otherwise it returns an error object.
   * @param {AbstractControl} control - The `control` parameter is an instance of the
   * `AbstractControl` class, which represents a form control in Angular. It can be a form control,
   * form group, or form array. In this case, it is used to access the value of the form control
   * being validated.
   * @returns either `null` or an object `{ invalidCpeDifferentNetwork: true }`.
   */
  static differentNetworkOperatorCpe(control: AbstractControl): {} | null {
    const VALIDATE_PREFIX = ['PT0001', 'PT0002'];
    const { value } = control;

    if (VALIDATE_PREFIX.some((item: string) => value.startsWith(item))) {
      return null;
    }

    return { invalidCpeDifferentNetwork: true };
  }
}
